module.exports = __webpack_public_path__ + "static/media/results-mapped.5335062d.png";